module.exports = __webpack_public_path__ + "static/media/11.73931445.jpg";